import {
	itemMetadataToFormDefaultValues,
	itemMetadataToChildrenFormDefaultValues,
} from '@bluheadless/ui-logic/src/utils/product'
import ProductProvider from '@bluheadless/ui-logic/src/providers/product'
import { object, oneOf } from 'prop-types'
import TileWishListBridge from './tile-wish-list-bridge'
import { variants } from './tile-variants'

const TileWishList = ({ item, variant, ...props }) => {
	return (
		<ProductProvider
			product={item?.productData}
			defaultQty={item?.qty}
			formDefaultValues={itemMetadataToFormDefaultValues(item)}
			childrenFormDefaultValues={itemMetadataToChildrenFormDefaultValues(item)}
			pageContext={props?.pageContext}
			pageId={props?.pageId}
			widgetContext={props?.widgetContext}
		>
			<TileWishListBridge
				Tile={variants[variant ?? 'base']}
				productOptions={item?.productOptions}
				variant={variant}
				{...props}
			/>
		</ProductProvider>
	)
}

TileWishList.defaultProps = {
	variant: 'base',
}

TileWishList.propTypes = {
	/**
	 * The product to display in the tile.
	 */
	item: object.isRequired,
	/**
	 * The variant to use.
	 */
	variant: oneOf(Object.keys(variants)).isRequired,
}

export default TileWishList
